import { Feature } from '@tencent/workbench';
import BaseGridFeature from '@framework/workbench/common/feature/base-grid-feature';
import { config } from './config';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

@Feature()
export class BorderStyleFeature extends BaseGridFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public shouldHide() {
        const model = this.getSelectionService().getSelectedModel();
        if (model) {
            const { type } = model;
            return type !== UIModelType.TABLE;
        }
        return true;
    }
}
